import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_DECISION_MAKERS_AUTOADD_ENABLED = createFcmDetails('decision_makers_autoadd_enabled', {
	owner: 'Capybara',
	context: 'Controls whether recommended decision makers are automatically added to a petition',
	description:
		'In petition service, after decision makers are recommended, this flag controls whether they are automatically added to the petition (if no decision makers have been added yet)',
	import: false,
});
